import React from 'react';
import { motion } from 'framer-motion';
interface PeriscanLogoProps {
  className?: string;
  size?: number;
  markColor?: string;
  textColor?: string;
  variant?: 'mark' | 'wordmark' | 'lockup';
  animated?: boolean;
}
export function PeriscanLogo({
  className = '',
  size = 64,
  markColor = '#0a7cc4',
  textColor = 'currentColor',
  variant = 'mark',
  animated = false
}: PeriscanLogoProps) {
  if (variant === 'mark') {
    return <svg height={size} viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg" fill="none" className={className} aria-label="Periscan" role="img" data-id="element-1124">
        <RadarMark color={markColor} animated={animated} data-id="element-1125" />
      </svg>;
  }
  if (variant === 'wordmark') {
    return <svg height={size} viewBox="0 0 460 200" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Periscan" role="img" data-id="element-1126">
        <Wordmark color={textColor} data-id="element-1127" />
      </svg>;
  }
  return <svg height={size} viewBox="0 0 720 200" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Periscan" role="img" data-id="element-1128">
      <Wordmark color={textColor} data-id="element-1129" />
      <g transform="translate(490, 0)" data-id="element-1130">
        <RadarMark color={markColor} animated={animated} data-id="element-1131" />
      </g>
    </svg>;
}
function Wordmark({
  color
}: {
  color: string;
}) {
  return <text x="0" y="158" fontFamily="Inter, system-ui, -apple-system, sans-serif" fontWeight={900} fontSize={180} letterSpacing="-8" fill={color} data-id="element-1132">
      Periscan
    </text>;
}
function RadarMark({
  color,
  animated
}: {
  color: string;
  animated: boolean;
}) {
  const cx = 110;
  const cy = 110;
  const strokeWidth = 14;
  return <g data-id="element-1133">
      {animated ? <>
          <AnimatedRing cx={cx} cy={cy} r={97} color={color} sw={strokeWidth} delay={0} data-id="element-1134" />
          <AnimatedRing cx={cx} cy={cy} r={72} color={color} sw={strokeWidth} delay={0.4} data-id="element-1135" />
          <AnimatedRing cx={cx} cy={cy} r={47} color={color} sw={strokeWidth} delay={0.8} data-id="element-1136" />
        </> : <>
          <circle cx={cx} cy={cy} r={97} stroke={color} strokeWidth={strokeWidth} fill="none" data-id="element-1137" />
          <circle cx={cx} cy={cy} r={72} stroke={color} strokeWidth={strokeWidth} fill="none" data-id="element-1138" />
          <circle cx={cx} cy={cy} r={47} stroke={color} strokeWidth={strokeWidth} fill="none" data-id="element-1139" />
        </>}
      <circle cx={cx} cy={cy - 32} r={22} fill={color} data-id="element-1140" />
    </g>;
}
function AnimatedRing({
  cx,
  cy,
  r,
  color,
  sw,
  delay
}: {
  cx: number;
  cy: number;
  r: number;
  color: string;
  sw: number;
  delay: number;
}) {
  return <motion.circle cx={cx} cy={cy} r={r} stroke={color} strokeWidth={sw} fill="none" animate={{
    opacity: [1, 0.45, 1]
  }} transition={{
    duration: 2.4,
    delay,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-1141" />;
}